"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEvents = exports.events = exports.event = exports.Event = void 0;
var unique_1 = require("../../utils/unique");
var METADATA_KEY = "journey-component:events";
exports.Event = {
    onClick: "onClick",
    onDoubleClick: "onDoubleClick",
    onFocus: "onFocus",
    onBlur: "onBlur",
    onChange: "onChange",
    onValidateSuccess: "onValidateSuccess",
    onValidateFail: "onValidateFail",
};
function event(name) {
    return function (constructor) {
        var settings = [];
        if (Reflect.hasMetadata(METADATA_KEY, constructor)) {
            settings = Reflect.getMetadata(METADATA_KEY, constructor);
        }
        settings = settings.concat(name);
        Reflect.defineMetadata(METADATA_KEY, (0, unique_1.unique)(settings), constructor);
    };
}
exports.event = event;
function events(names, noInherited) {
    return function (constructor) {
        var settings = [];
        if (!noInherited && Reflect.hasMetadata(METADATA_KEY, constructor)) {
            settings = Reflect.getMetadata(METADATA_KEY, constructor);
        }
        settings = settings.concat(names);
        Reflect.defineMetadata(METADATA_KEY, (0, unique_1.unique)(settings), constructor);
    };
}
exports.events = events;
function getEvents(constructor) {
    if (Reflect.hasMetadata(METADATA_KEY, constructor)) {
        return Reflect.getMetadata(METADATA_KEY, constructor);
    }
    return undefined;
}
exports.getEvents = getEvents;
//# sourceMappingURL=events.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-model/dist/journey/annotations/events.js
// module id = 2094
// module chunks = 0